// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MEXcv","label":"styles_label__51fpE","textarea":"styles_textarea__ubF9M","count":"styles_count__TZKLT","error":"styles_error__vYaCR"};